<template lang='pug'>
.request-details(:class='{ "has-location" : location !== null }')
	viewer(
		v-if='location.lat && location.lng'
		:pin='location'
		@ready='setMapCenter'
	)
	.information
		.title
			h1
				span.light Request
				span  {{ request.number }}
			//- .button.outline(@click='$emit( "edit" )')
			//- 	.icon-pencil
			//- 	span Edit
		.icons
			.icon(v-if='request.facilities.length')
				.icon-water
				span
					span(v-for='( facility, i ) in request.facilities') {{ i === 0 ? '' : ', ' }}{{ facility.name }} No. {{ facility.number }}
			.icon
				.icon-person-outlined
				span {{ request.requestingParty }} - {{ dateOf( request.dateRequested, 'GMT' ) }}

		document-list(
			:class='documentsShowing'
			:documents='request.files'
			:assetKey='request.actionRequestsKey'
			@document-clicked='openDocument'
			@close='$emit( "close" )'
		)

		.expand-info(@click='setExpandState')
			p Expand all Info
			.clickable-arrow(:class='expandState')

		.info
			list-layout(
				:layout='listItems'
				:parentObj='formattedRequest'
				:class='{ "slide-in" : expandState === "open" }'
			)
</template>

<script>
import Submit from '@/lib/Submit';
import Viewer from '@/components/map/Viewer';
import Comments from '@/components/comments';
import ListLayout from '@/components/ListLayout';
import DocumentList from '@/components/DocumentList';
import gmapsInit from '@/lib/gmaps';

import { objectOrNull } from '@/lib/vue-validators';
import { editRequest } from '@/lib/generate';
import { FormatDate } from '@/lib/utils';

export default {
	name : 'request',

	props : {
		request : {
			required  : true,
			validator : objectOrNull,
		}
	},

	data : () => ( {
		expandState      : 'close',
		google           : null,
		documentsShowing : 'closed',

		listItems : {
			items : {
				dateRequested : 'Request Date',
				number        : 'Request Number',
				facilities    : {
					items : {
						name : 'Facilities',
					}
				},
				requestingParty : 'Requesting Party',
				comments        : 'Comments',
				summary         : 'Project Summary',
				job             : {
					items : {
						number : 'Job Number'
					}
				},
				rulingAction : {
					items : {
						description : 'Ruling Action'
					}
				},
				fidContributions : 'FID Contributions',
				location         : {
					items : {
						description : 'Cross Streets',
					}
				},
				infoItem : 'Info Item',
			}
		}
	} ),

	computed : {

		formattedRequest() {

			const { request } = this;
			const {
				dateRequested,
				...otherProps
			} = request;

			let { fidContributions } = request;

			const dates = {
				dateRequested
			};

			const formattedDates = Object.keys( dates ).reduce( ( obj, key ) => {
				const date = dates[key];
				const added = {};

				added[key] = FormatDate( new Date( date ), 'MMMM D, YYYY', 'GMT' );

				return {
					...obj,
					...added,
				};
			}, {} );

			const addDollarSign = ( fee ) => {

				if ( !fee && fee !== 0 ) {
					return null;
				}

				if ( fee[0] === '$' ) {
					return fee;
				}

				return `$${fee}`;

			};

			fidContributions = addDollarSign( fidContributions );

			return {
				...formattedDates,
				...otherProps,
				fidContributions,
			};

		},

		user() {
			return this.$store.state.postgresUser;
		},

		location() {
			const { location } = this.request;

			if ( !location || !Object.keys( location || {} ).length ) {
				return null;
			}

			return {
				lat : location.latitude,
				lng : location.longitude,
			};
		},

	},
	async mounted() {
		this.google = await gmapsInit();
	},

	methods : {

		openDocument( document ) {
			this.$store.dispatch( 'openDocument', document.name );
		},

		toggleDocumentsShowing() {
			this.expandState = 'close';

			if ( this.documentsShowing === 'opened' ) {
				this.documentsShowing = 'closed';
				return;
			}

			this.documentsShowing = 'opened';
		},

		setExpandState() {

			this.documentsShowing = 'closed';

			const { expandState } = this;
			this.expandState = expandState === 'open' ? 'close' : 'open';
		},

		editRequest() {

			const changedRequest = editRequest( this.request );

			Submit.editRequest( changedRequest, this.request.key, 'Editing Request Status...' );
		},

		setMapCenter( map ) {
			const { location } = this;

			map.setCenter( new this.google.maps.LatLng( location.lat + 0.01, location.lng ) );
		},

		dateOf( date, timezone = 'GMT' ) {
			return FormatDate( date, 'MMMM D, YYYY', timezone );
		},

	},

	components : {
		Viewer,
		Comments,
		ListLayout,
		DocumentList,
	}
};
</script>

<style lang='scss'>

.request-details {

	.viewer {
		border-radius: 0;

		+ .information {
			padding-top: 0;
		}
	}

	.information {
		padding-top: 50px;

		.document-list {
			position: relative;
			padding: 0 30px 0px 30px;
			width: 100%;
			left: 0;
			opacity: 1;
			transform: translateY(0);
			pointer-events: all;
			z-index: 1;
			max-height: 1000px;
			transition: max-height .2s ease-in, transform .2s ease-in, opacity .2s ease-in;

			&.closed {
				opacity: 0;
				transform: translateY(-100%);
				padding: 0 30px;
				z-index: -1;
				max-height: 0;
				pointer-events: none;
			}
		}
	}

	.title {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 15px 30px;

		h1 {
			margin: 0;

			span {
				color: $color-primary;

				&.light {
					opacity: 0.8;
				}
			}
		}
	}

	.icons {
		padding: 15px 30px;
		padding-top: 0;

		.icon {
			display: flex;
			align-items: center;
			color: $input-color;

			span {
				display: inline !important;
			}

			+ .icon {
				margin-top: 10px;
			}

			[class^='icon'] {
				margin-right: 10px;
			}
		}
	}

	.download-document {
		padding: 0 30px;
		display: flex;
		align-items: center;
		margin-bottom: 15px;

		p {
			width: fit-content;
			color: $color-primary;
			cursor: pointer;
			position: relative;
			background-image: linear-gradient(to right, $color-primary 50%, rgba(255,255,255,0) 0%);
			background-position: bottom;
			background-size: 6px 2px;
			background-repeat: repeat-x;
			margin-right: 15px;
		}
	}

	.comments {
		padding: 0 30px;
		margin-bottom: 15px;
	}

	.expand-info {
		margin: 0 30px 15px 30px;

		p {
			text-align: left;
		}
	}

	.info {

		.list-layout {
			padding: 0 30px 15px 30px;

			&:not(.slide-in) {
				padding-bottom: 0;
			}
		}
	}

	.comment-section > .comment-thread-container {
		padding: 0 15px;
	}
}

@media only screen and ( max-width: 640px ) {

	.request-details {

		.viewer + .information .title {
			margin-top: 10px !important;
		}

		.information .title {
			margin-top: 30px;

			.button.outline {
				display: none;
			}
		}

		.download-document {
			display: none;
		}

		.info .list-layout .section {

			.list-item {
				flex: 0 0 100%;
			}
		}

		.comment-section {

			.comment-count {
				padding: 15px 30px;
			}

			.add-comment .comment-wrapper {
				margin: 15px 30px;
			}
		}
	}
}
</style>
